export default {
  savingAdjustment: false,
  removingAdjustment: false,
  adjustmentsCollection: [],
  adjustmentsFilter: '',
  accountsFetching: false,
  accounts: [],
  adjustmentAttachments: [],
  bookToTaxDifferencesCollection: [],
  bookToTaxDifferencesFilter: '',
  NOLRollforwardsCollection: [],
  NOLRollforwardFilter: '',
  fetchingInitialDataForAdjustmentModal: false,
  fetchingAttachments: false,
};
